import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import {
  DashboardDialog,
  DashboardDialogBody,
  DashboardDialogContent,
  DashboardDialogFooter,
  DashboardDialogHeader,
} from "@/dashboard-design-system/DashboardDialog";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Delete } from "@/icons/outlined";

interface DeleteCategoryConfirmModalProps {
  open: boolean;
  categoryName: string;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteCategoryConfirmModal: FC<DeleteCategoryConfirmModalProps> = ({
  open,
  categoryName,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslate();

  return (
    <DashboardDialog open={open} onClose={onCancel} vibe="danger" maxWidth="xs">
      <DashboardDialogBody
        slots={{
          header: (
            <DashboardDialogHeader
              icon={<Delete />}
              title={t("dashboard", "ticketing.categories.delete.title", { name: categoryName })}
            />
          ),
          content: (
            <DashboardDialogContent>
              <DashboardTypography variant="body2" vibe="text-neutral-quiet">
                {t("dashboard", "ticketing.categories.delete.description")}
              </DashboardTypography>
            </DashboardDialogContent>
          ),
          footer: (
            <DashboardDialogFooter>
              <DashboardButton vibe="danger" onClick={onConfirm} isLoading={isLoading}>
                {t("dashboard", "ticketing.categories.delete.confirm")}
              </DashboardButton>
              <DashboardButton vibe="neutral" variant="outlined" onClick={onCancel}>
                {t("dashboard", "common.cancel")}
              </DashboardButton>
            </DashboardDialogFooter>
          ),
        }}
      />
    </DashboardDialog>
  );
};
